import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import ClientCatalog from "@/pages/ClientCatalog";
import ClientLogin from "@/pages/ClientLogin";
import Confirmation from "@/pages/Confirmation";
import MyOrders from "@/pages/MyOrders";
import { IosGate } from "@/components/IosGate";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import StaffLogin from "@/pages/StaffLogin";
import DriverDashboard from "@/pages/DriverDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import "@/App.css";

function Loading() {
  return <div className="min-h-screen flex items-center justify-center text-amber-400 font-mono">Chargement…</div>;
}

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/staff" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : user.role === "livreur" ? "/driver" : "/"} replace />;
  return children;
}

function ClientProtected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "client") return <Navigate to={user.role === "admin" ? "/admin" : "/driver"} replace />;
  return <IosGate>{children}</IosGate>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<ClientLogin />} />
              <Route path="/" element={<ClientProtected><ClientCatalog /></ClientProtected>} />
              <Route path="/orders" element={<ClientProtected><MyOrders /></ClientProtected>} />
              <Route path="/order/:id" element={<ClientProtected><Confirmation /></ClientProtected>} />
              <Route path="/payment/success" element={<ClientProtected><PaymentSuccess /></ClientProtected>} />
              <Route path="/payment/cancel" element={<ClientProtected><PaymentCancel /></ClientProtected>} />
              <Route path="/staff" element={<StaffLogin />} />
              <Route path="/driver" element={<Protected role="livreur"><DriverDashboard /></Protected>} />
              <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
